import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IncidentCategoryDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-incidentcategory',
  templateUrl: './incidentcategory.component.html',
  styleUrls: ['./incidentcategory.component.scss']
})
export class IncidentCategoryComponent implements OnChanges {


  incidentcategoryForm: FormGroup;
  incidentcategoryFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentcategorys: IncidentCategoryDto[];
  @Input() routeAnimationsElements: any;
  @Output() incidentcategory = new EventEmitter<IncidentCategoryDto[]>()
  @Output() deleteIncidentCategoryEvent = new EventEmitter<any>()

    selectedIncidentCategory: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createIncidentCategoryForm();
    }

    createIncidentCategoryForm() {
      this.incidentcategoryForm = this.fb.group({
        IncidentCategoryName: ['', Validators.required],
     
        id: null
        });
        this.incidentcategoryFormArray = this.fb.group({ IncidentCategorys: this.fb.array([])
          });
        this.setIncidentCategory();
    }

  // method to display incidentcategorys
  setIncidentCategory() {
    const control  = this.incidentcategoryFormArray.controls.IncidentCategorys as FormArray;
    this.incidentcategorys.forEach( e => {
      control.push(
        this.fb.group({
          IncidentCategoryName: e.IncidentCategoryName,
        
          id: e.id
        })
      );
    });
  }


  // method to add IncidentCategory
  addIncidentCategory(value: IncidentCategoryDto) {
    const control  = this.incidentcategoryFormArray.controls.IncidentCategorys as FormArray;
    control.insert(0,
          this.fb.group({
            IncidentCategoryName: value.IncidentCategoryName,
          
            id: null
          })
       );
  }

  selectIncidentCategory(value) {}

  // method to delete incidentcategory from arrary list
  deleteIncidentCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.incidentcategoryFormArray.controls.IncidentCategorys as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.incidentcategorys.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.incidentcategorys[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IncidentCategoryDto) {
    if(this.incidentcategoryForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.incidentcategoryFormArray.get('IncidentCategorys')['controls'][this.selectedIndex].patchValue({IncidentCategoryName: formValue.IncidentCategoryName});
    } else {
      this.addIncidentCategory(formValue);
    }
    this.selectedIndex = null;
    this.incidentcategoryForm.reset()
  }

  onEdit(index, value: IncidentCategoryDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.incidentcategoryForm.patchValue({IncidentCategoryName: value.IncidentCategoryName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentcategoryForm.reset();
  }

  onSubmit(formValue: IncidentCategoryDto[]) {
  this.incidentcategory.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteIncidentCategoryEvent.emit(this.filteredDelete);
  }
  }

}
